import { useMemo } from 'react';
import { Chip, styled, Typography } from '@mui/material';
import { assertUnreachable } from '@levelworks/shared-utils-ts';
import { ServiceAgreementState } from 'ogp/services/service-agreements.types';
import { useMapServiceAgreementStateToTranslation } from '../../hooks/use-map-service-agreement-state-to-translation';

export const ServiceAgreementStateChip = ({ type }: { type: ServiceAgreementState }) => {
  const { mapStateToTranslation } = useMapServiceAgreementStateToTranslation();
  const { stateTranslation, backgroundColour } = useMemo(() => {
    const stateTranslation = mapStateToTranslation(type);
    switch (type) {
      case 'ACCEPTED':
        return {
          stateTranslation,
          backgroundColour: 'rgba(0, 236, 43, 0.2)',
        };
      case 'PENDING':
        return {
          stateTranslation,
          backgroundColour: 'rgba(255, 204, 0, 0.2)',
        };
      case 'REJECTED':
        return {
          stateTranslation,
          backgroundColour: 'rgba(255, 0, 0, 0.2)',
        };
      case 'TERMINATED':
        return {
          stateTranslation,
          backgroundColour: 'rgba(255, 0, 0, 0.2)',
        };
      default:
        assertUnreachable(type);
    }
  }, [type]);
  return (
    <StyledChip
      label={<Typography>{stateTranslation}</Typography>}
      size="small"
      sx={{ backgroundColour }}
    />
  );
};

const StyledChip = styled(Chip)(({ theme }) => ({
  height: 'auto',
  margin: 0,
  '& .MuiChip-label': {
    whiteSpace: 'normal',
    padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
  },
}));
